import React from "react";
import "../../../pages/Surveys/style.css"
import cogoToast from "cogo-toast";
import "survey-core/defaultV2.min.css";
import "survey-creator-core/survey-creator-core.min.css";
import { Card, CardBody, Label, Input } from "reactstrap";
import { useState, useEffect, useMemo, useRef } from "react";
import { genericGet, genericPost } from "../../../services/Api";
import { SUCCESS_RESULT, ENDPOINTS, LOCAL_PATHS } from "../../../Constants";

 
import { FaTimes, FaEdit, FaFileExport,FaArrowRight, FaExclamationCircle, FaTimesCircle, FaCheckCircle } from "react-icons/fa";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { useHistory } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import ability from '../../config/defineAbility';
import { PERMS } from '../../config/perms'


const PendingActions = (props) => {
  const history = useHistory();
  const [is_loading, setIsLoading] = useState(false);

  const { data } = (props.location && props.location.state) || {};
  const [rowData, setRowData] = useState([]);
  const gridRef = useRef();
  const [gridApi, setGridApi] = useState(null);
  const defaultColDef = useMemo(() => {
    return {
      editable: false,
      sortable: true,
      flex: 1,
      minWidth: 100,
      filter: true,
      resizable: true,
    };
  }, []);

  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetch_data();
    return () => {};
  }, []);

  const fetch_data = () => {
    setIsLoading(true);
 
    genericGet(ENDPOINTS.LEAVE_PENDING_ACTIONS)
    .then((res) => {
        setIsLoading(false);
        if (res.status == 200) {
            if (res.data.status == SUCCESS_RESULT) {
                let responseData = res.data.data;
             
                setRowData(responseData);
            } else {
                cogoToast.error(res.data.message, {});
            }
        }
    })
    .catch((err) => {
        setIsLoading(false);
        console.log(err);
    });
   
  };

  const filteredRows = useMemo(() => {
    const q = (searchTerm || "").trim().toLowerCase();
    if (!q) return rowData || [];

    return (rowData || []).filter((r) => {
      const leaveType = r?.leave_type?.name || "";
      const reason = r?.leave_reason || "";
      const createdBy = r?.created_by?.name || "";
      const requestDate = r?.request_date || "";
      const totalDays = r?.total_days ?? "";

      return (
        leaveType.toLowerCase().includes(q) ||
        reason.toLowerCase().includes(q) ||
        createdBy.toLowerCase().includes(q) ||
        requestDate.toLowerCase().includes(q) ||
        String(totalDays).toLowerCase().includes(q)
      );
    });
  }, [rowData, searchTerm]);

  const openApproval = (leaveRow) => {
    if (!leaveRow?.id) return;
    history.push({
      pathname: `${LOCAL_PATHS.LEAVE_PENDING_ACTIONS}/${leaveRow.id}`,
      state: { data: leaveRow },
    });
  };

  return (
    <div>
          <h1> Pending Actions</h1>
      <div className="ag-theme-alpine" style={{ display: "none" }}>
        <AgGridReact
          suppressMenuHide={true}
          ref={gridRef}
          //   overlayLoadingTemplate={
          //     '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
          //   }

          overlayLoadingTemplate={
            '<span className="ag-overlay-loading-center"> loading data...</span>'
          }
          onGridReady={(params) => {
            setGridApi(params.api);
            params.api.showLoadingOverlay();
          }}
          rowData={rowData}
          domLayout={"autoHeight"}
          animateRows={true}
          onRowDoubleClicked={(e) => history.push({
            pathname: LOCAL_PATHS.LEAVE_PENDING_ACTIONS,
            state: { data: e.data },
          })}
          pagination={true}
          paginationPageSize={100}
          defaultColDef={defaultColDef}
          resizable={true}
          enableCellTextSelection={true}
          suppressCellSelection={true}
          columnDefs={[
            {
              headerName: "#",
              filter: false,
              maxWidth: 70,
              sortable: true,
              valueFormatter: function (params) {
                return `${parseInt(params.node.id) + 1}`;
              },
            },

            {
              headerName: "Leave Type",
            
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
return e?.data?.leave_type?.name??"";
              }
            },
            {
              headerName: "Request Date",
              field: "request_date",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Total Days",
              field: "total_days",
              sortable: true,
              filter: true,
            },
            {
              headerName: "Reason ",
              field: "leave_reason",
              sortable: true,
              filter: true,
            
            },
            {
              headerName: "Created By ",
              field: "created_by",
              sortable: true,
              filter: true,
              cellRendererFramework: (e) => {
                return e?.data?.created_by?.name;
                              }
            },
           

            {
              headerName: "Actions",
              field: "",
              sortable: true,
              filter: true,
             
              cellRendererFramework: (e) => {
                return (
                 
    

                  <button
                  className="badge btn-primary"
                    onClick={() => {
                    
try{
                      history.push({
                        pathname: LOCAL_PATHS.LEAVE_PENDING_ACTIONS+"/"+e.data.id,
                        state: { data: e.data },
                      });

                    }catch(e){
                      alert(e)
                    }
                    }}
                  >
                    View   &nbsp;  <FaArrowRight style={{ color: "white", cursor: "pointer" }} />
                  </button>
                  
                  
                  
           

                );
              },
            },




          ]}
        ></AgGridReact>
      </div>{" "}

      <div style={{ paddingTop: 10 }}>
        <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
          <div style={{ flex: 1 }}>
            <div className="text-muted" style={{ fontSize: 13 }}>
              Search and click a row to open the approval screen.
            </div>
          </div>

          <div style={{ width: 320, maxWidth: "100%" }}>
            <Label className="mb-1" style={{ fontSize: 13 }}>
              Search
            </Label>
            <Input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search by type, reason, creator..."
            />
          </div>
        </div>

        <Card className="shadow-sm border-0" style={{ borderRadius: 12 }}>
          <CardBody style={{ padding: 0 }}>
            {is_loading ? (
              <div className="p-4 text-center">
                <PulseLoader color="#36d7b7" />
                <div className="text-muted" style={{ fontSize: 13, marginTop: 8 }}>
                  Loading data...
                </div>
              </div>
            ) : (
              <div style={{ display: "flex", flexDirection: "column", gap: "16px", marginTop: 4 }}>
                {filteredRows.length ? (
                  filteredRows.map((r, idx) => (
                    <div
                      key={r?.id || idx}
                      onClick={() => openApproval(r)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") openApproval(r);
                      }}
                      style={{
                        backgroundColor: "white",
                        borderRadius: "12px",
                        padding: "20px",
                        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                        border: "1px solid #e0e0e0",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                        position: "relative",
                        overflow: "hidden",
                        gap: "20px",
                        alignItems: "center",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.transform = "translateX(4px)";
                        e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.15)";
                        e.currentTarget.style.borderColor = "#2196f3";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateX(0)";
                        e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.1)";
                        e.currentTarget.style.borderColor = "#e0e0e0";
                      }}
                    >
                      <div
                        style={{
                          position: "absolute",
                          top: 0,
                          left: 0,
                          bottom: 0,
                          width: "4px",
                          background: "linear-gradient(180deg, #2196f3, #42a5f5)",
                        }}
                      />

                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                          paddingLeft: "8px",
                          minWidth: 0,
                        }}
                      >
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "15px", flexWrap: "wrap" }}>
                          <div style={{ minWidth: 220 }}>
                            <div style={{ fontSize: "20px", fontWeight: 600, color: "#333", lineHeight: "1.3" }}>
                              {r?.leave_type?.name || "Leave Request"}
                            </div>
                            <div style={{ marginTop: 4, color: "#666", fontSize: 13 }}>
                              <span style={{ fontWeight: 600 }}>{r?.request_date || "-"}</span>
                              <span style={{ margin: "0 10px", color: "#999" }}>•</span>
                              {r?.total_days ?? "-"} day(s)
                            </div>
                          </div>

                          <div style={{ display: "flex", gap: 10, alignItems: "center", flexWrap: "wrap", justifyContent: "flex-end" }}>
                            <span className="badge btn-primary" style={{ fontSize: 13 }}>
                              View <FaArrowRight style={{ marginLeft: 6, color: "white" }} />
                            </span>
                          </div>
                        </div>

                        <div style={{ fontSize: 14, color: "#666", lineHeight: 1.4, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>
                          <span style={{ fontWeight: 600, color: "#444" }}>Reason:</span> {r?.leave_reason || "-"}
                        </div>

                        <div style={{ fontSize: 12, color: "#999" }}>
                          Created by: <span style={{ color: "#666", fontWeight: 600 }}>{r?.created_by?.name || "-"}</span>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="text-center text-muted" style={{ padding: 28 }}>
                    No pending leave requests found.
                  </div>
                )}
              </div>
            )}
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default PendingActions;
